export function setTrackingCookiesFromParams(query = {}) {
    if (typeof query !== 'object' || Object.keys(query).length <= 0) {
        return
    }
    const { $lendioCookies } = useNuxtApp()
    const { public: publicConfig } = useRuntimeConfig()

    $lendioCookies.setCookiesFromParams(query, {
        secure: publicConfig?.environment !== 'dev'
    })
}
